<div class="card" [formGroup]="form">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.BasicInfo" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-action btn-primary pull-right"
                        [disabled]="isOtherItemEdited"
                        hznTestId="camp-basic-info-edit"
                        (click)="edit()"
                    >
                        {{ "General.Edit" | translate }}
                    </button>
                }
            </div>
        </div>

        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.Type" | translate }}
                </div>
                <div class="col-sm-10">{{ campTypeLabel }}</div>
            </div>
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.Status" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-basic-info-status">
                    {{ translateStatus(form.controls.status.value) }}
                </div>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.UniqueName" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-basic-info-name">{{ form.controls.name.value }}</div>
            </div>
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.HoldingAccount" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-basic-info-holding-account-value">
                    {{ form.controls.holdingAccount.value }}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.RevenueDepartment" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-basic-info-revenue-department-value">
                    {{ form.controls.revenueDepartment.value }}
                </div>
            </div>
        </div>

        <app-camp-category [form]="categoryForm"></app-camp-category>

        @if (isChildcareCamp) {
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{
                        "CampDetails.ReservationDaysAheadLimitVariant"
                            | translate
                    }}
                </div>
                <div class="col-sm-10">
                    {{
                        translateReservationDaysAheadLimitVariant(
                            form.controls.reservationDaysAheadLimitVariant.value
                        )
                    }}
                </div>
            </div>
        }

        @if (isChildcareCamp) {
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.ReservationDaysAheadLimit" | translate }}
                </div>
                <div class="col-sm-10">
                    {{ form.controls.reservationDaysAheadLimit.value | json }}
                </div>
            </div>
        }
    </div>
</div>
